module.exports = __webpack_public_path__ + "static/contact_image_mobile-76a2c6cbcce323c527a93ed0da9679f7.jpg";